"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_STORAGE_BATCH_TIME = exports.TAB_ID_STORAGE_KEY = exports.SUBSCRIPTION_OWNERS = exports.STUDENT_RECORD_TYPES = exports.STUDENT_LOCATION_STATUSES = exports.SHARED_STORAGE_BATCH_TIME = exports.ROLES = exports.PROVIDERS = exports.PRESENCE_EVENT_TYPE = exports.PRESENCE_ACTIONS = exports.MAX_CLASSROOM_RECORD_AGE = exports.HEARTBEAT_INTERVAL = exports.EYES_UP_STATUSES = exports.EVENT_BATCH_SIZE = exports.CLASS_STATUSES = exports.CLASS_RECORD_TYPES = exports.AUTOSAVE_BATCH_TIME = void 0;
var PROVIDERS = {
  ABLY: 'ably'
};
exports.PROVIDERS = PROVIDERS;
var CLASS_RECORD_TYPES = {
  CLASS_STATUS: 'class-status',
  CLASS_LOCATION: 'class-location',
  CLASS_PACING: 'class-pacing',
  EYES_UP: 'eyes-up',
  CLASS_WORK_ASSIGNMENT: 'class-work-assignment',
  CLASS_SHAREOUT_ACTIVITY: 'class-shareout-activity'
};
exports.CLASS_RECORD_TYPES = CLASS_RECORD_TYPES;
var STUDENT_RECORD_TYPES = {
  STUDENT_LOCATION: 'student-location',
  STUDENT_AUTOSAVE: 'student-autosave',
  STUDENT_SUBMISSION: 'student-submission',
  STUDENT_STORAGE_SAVE: 'student-storage-save',
  STUDENT_SHARED_DATA: 'shared-student-data',
  STUDENT_VARIANT_CHANGE: 'student-variant-change',
  STUDENT_HAND_RAISE_CHANGE: 'student-hand-raise-change'
};
exports.STUDENT_RECORD_TYPES = STUDENT_RECORD_TYPES;
var CLASS_STATUSES = {
  STARTED: 'ACTIVE',
  NOT_STARTED: 'INACTIVE',
  // Deprecated
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};
exports.CLASS_STATUSES = CLASS_STATUSES;
var EYES_UP_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};
exports.EYES_UP_STATUSES = EYES_UP_STATUSES;
var STUDENT_LOCATION_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  HANDED_IN: 'HANDED_IN',
  NOT_SUBMITTABLE: 'NOT_SUBMITTABLE'
};
exports.STUDENT_LOCATION_STATUSES = STUDENT_LOCATION_STATUSES;
var AUTOSAVE_BATCH_TIME = 5000; // ms

exports.AUTOSAVE_BATCH_TIME = AUTOSAVE_BATCH_TIME;
var USER_STORAGE_BATCH_TIME = 5000; // ms

exports.USER_STORAGE_BATCH_TIME = USER_STORAGE_BATCH_TIME;
var SHARED_STORAGE_BATCH_TIME = 5000; // ms

exports.SHARED_STORAGE_BATCH_TIME = SHARED_STORAGE_BATCH_TIME;
var EVENT_BATCH_SIZE = 100; // timeout should happen between 2-3 mins

exports.EVENT_BATCH_SIZE = EVENT_BATCH_SIZE;
var MAX_CLASSROOM_RECORD_AGE = 180000; // heartbeat is set to trigger mark a class as active such that the timeout is only hit if 2 consecutive
// heartbeats fail to get through

exports.MAX_CLASSROOM_RECORD_AGE = MAX_CLASSROOM_RECORD_AGE;
var HEARTBEAT_INTERVAL = MAX_CLASSROOM_RECORD_AGE / 3;
exports.HEARTBEAT_INTERVAL = HEARTBEAT_INTERVAL;
var ROLES = {
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  ALL: 'ALL' // used for sending messages to all roles.

};
exports.ROLES = ROLES;
var SUBSCRIPTION_OWNERS = {
  CLIENT: 'client',
  CLASS_STATE_SERVICE: 'classStateService'
};
exports.SUBSCRIPTION_OWNERS = SUBSCRIPTION_OWNERS;
var PRESENCE_EVENT_TYPE = 'presence';
exports.PRESENCE_EVENT_TYPE = PRESENCE_EVENT_TYPE;
var PRESENCE_ACTIONS = {
  JOIN: 'join',
  LEAVE: 'leave'
};
exports.PRESENCE_ACTIONS = PRESENCE_ACTIONS;
var TAB_ID_STORAGE_KEY = 'amp-realtime-tab-id';
exports.TAB_ID_STORAGE_KEY = TAB_ID_STORAGE_KEY;
//# sourceMappingURL=constants.js.map